module.exports = __webpack_public_path__ + "static/media/Kontakt_4_Fon_.a0edc5ec.jpg";